import {
  CertificateAction,
  CertificateEventLine,
  CertificateRecapModal,
} from "@mytour/chimney-sweeping";
import type {
  CertificateCustomerQueries,
  CertificateEventProps,
  CertificateRecapProps,
} from "@mytour/chimney-sweeping";
import {
  customerDetailQueryOptions,
  customerUpdateMutationOptions,
} from "../../client/query/customerQueries";

const customerQueries = {
  detail: customerDetailQueryOptions,
  update: customerUpdateMutationOptions,
} satisfies CertificateCustomerQueries;

type LegacyEventProps = Omit<CertificateEventProps, "customerQueries">;
type LegacyRecapProps = Omit<CertificateRecapProps, "customerQueries">;

export function CertificatRamonageAction(props: LegacyEventProps) {
  return <CertificateAction {...props} customerQueries={customerQueries} />;
}

export function CertificatRamonageDocumentLine(props: LegacyEventProps) {
  return <CertificateEventLine {...props} customerQueries={customerQueries} />;
}

export function CertificatRamonageRecapModal(props: LegacyRecapProps) {
  return <CertificateRecapModal {...props} customerQueries={customerQueries} />;
}
